export const setSnackbarMessage = ({
  message,
  variant = 'default',
  autoHideDuration = 4000,
  persistent = false,
  icon,
  hideCloseIcon,
  additionalText,
}) => ({
  type: 'SET_SNACKBAR_MODE',
  message,
  variant,
  autoHideDuration,
  persistent,
  icon,
  hideCloseIcon,
  additionalText,
});

export const closeSnackbarMessage = (variant = 'default') => ({
  type: 'SET_SNACKBAR_CLOSED',
  variant,
});
